import React from 'react';
import styled from 'styled-components';
import { useAmp } from 'next/amp';
import NextImage from 'next/image';
import Link from 'app/components/misc/Link';

const Container = styled.div`
  display: flex;
  padding: 16px 0;
  font-size: 14px;
`;

const ImageContainer = styled.a`
  margin-right: 16px;
  img,
  amp-img {
    border-radius: 50%;
    height: 52px;
    width: 52px;
    object-fit: cover;
    background-color: ${props => props.theme.colors.neutral2};
  }
`;

const Name = styled.a`
  color: ${props => props.theme.colors.neutral7};
  font-weight: bold;
`;

const Description = styled.div`
  margin-top: 8px;
  color: ${props => props.theme.colors.neutral5};

  a {
    color: ${props => props.theme.colors.seedlyBlue};
  }
`;

const Image = ({ src }) => {
  const isAmp = useAmp();
  if (isAmp) return <amp-img src={src} width="52px" height="52px" />;
  return (
    <NextImage alt="profile" src={src} width={52} height={52} layout="fixed" />
  );
};

const AuthorProfile = ({ imageUrl, name, description, link }) => (
  <Container>
    <Link {...link}>
      <ImageContainer>
        <Image src={imageUrl} />
      </ImageContainer>
    </Link>
    <div>
      <Link {...link} passHref>
        <Name>About {name}</Name>
      </Link>
      <Description dangerouslySetInnerHTML={{ __html: description }} />
      <Description>
        {`You can contribute your thoughts like ${name} `}
        <Link href="/blog/submit-article" as="/submit-article">
          <a>here.</a>
        </Link>
      </Description>
    </div>
  </Container>
);

export default AuthorProfile;
